module.exports = __webpack_public_path__ + "static/media/bg.b6796c73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.jpg
// module id = 64
// module chunks = 0